var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#C8DBF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#D7E7FF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 22.0002H22.8C21.1198 22.0002 20.2798 22.0002 19.638 22.3272C19.0735 22.6148 18.6146 23.0738 18.327 23.6383C18 24.28 18 25.1201 18 26.8002V35.2002C18 36.8804 18 37.7205 18.327 38.3622C18.6146 38.9267 19.0735 39.3856 19.638 39.6732C20.2798 40.0002 21.1198 40.0002 22.8 40.0002H31.2C32.8802 40.0002 33.7202 40.0002 34.362 39.6732C34.9265 39.3856 35.3854 38.9267 35.673 38.3622C36 37.7205 36 36.8804 36 35.2002V31.0002M24 34.0002H25.6745C26.1637 34.0002 26.4083 34.0002 26.6385 33.945C26.8425 33.896 27.0376 33.8152 27.2166 33.7055C27.4184 33.5818 27.5914 33.4089 27.9373 33.063L37.5 23.5002C38.3284 22.6718 38.3284 21.3287 37.5 20.5002C36.6716 19.6718 35.3284 19.6718 34.5 20.5002L24.9372 30.063C24.5913 30.4089 24.4184 30.5818 24.2947 30.7837C24.185 30.9626 24.1042 31.1577 24.0552 31.3618C24 31.5919 24 31.8365 24 32.3257V34.0002Z",
    stroke: "#4773B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c4e7da5a2cc64902887644eb49a771ac.svg";
export { ForwardRef as ReactComponent };